import { useQuery } from '@tanstack/react-query';
import api from '../services/authService';

export const usePrivacyPolicy = () => {
  return useQuery({
    queryKey: ['privacyPolicy'],
    queryFn: async () => {
      const response = await api.get('/privacy-policy');
      return response.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

